<template>
  <div class="header">
    <div
        class="header-left"
        v-show="$route.path!='/tasks' && $route.path!='/coinRecord' && $route.path!='/testMode' && $route.path!='/studentAccount' && $route.path!='/selectStudying'&& $route.path!='/help'&& $route.path!='/gacha'&& $route.path!='/myGacha'&& $route.path!='/cardShop'"
    >
      <div class="box-grade cursor-pointer">
        <span @click="showAll=!showAll">
          {{currentGradeName||detail.subscriptions[detail.subscriptionIndex].gradeName}}
          <i class="el-icon-caret-bottom"></i>
        </span>
        <div v-if="showAll" class="box-grades">
          <div
              class="grades"
              :class="gradeId==item.id?'active':''"
              v-for="(item,index) in detail.subscriptions[detail.subscriptionIndex].subscribeAssignGrades"
              :key="index"
              @click="gradeChange(item)"
          >
            {{item.name }}
          </div>
        </div>
      </div>
      <div v-if="$route.path=='/adventure'" class="box-star">0/72</div>
    </div>
    <div
        class="header-left"
        v-show="$route.path=='/testMode' || $route.path=='/studentAccount' || $route.path=='/selectStudying'|| $route.path=='/help'|| $route.path=='/gacha'|| $route.path=='/myGacha'|| $route.path=='/cardShop'"
    ></div>

    <div class="title headerGuide1" ref="headerGuide1" :style="{opacity:$route.path=='/adventure'?'50%':''}">
      {{
        $route.path=='/tasks'?'':
        $route.path=='/coinRecord'?$t("studentProgramme.coinRecord"):
        $route.path=='/answerResult'?$t("studentProgramme.answerRecord"):
            $route.path=='/studentAccount'?$t("studentProgramme.myFile"):
                $route.path=='/adventure'?$t("studentProgramme.adventureMode"):
                    $route.path=='/libraryMode'?$t("studentProgramme.libraryMode"):
                        $route.path=='/selectStudying'?$t("studentProgramme.courseSwitching"):
                            $route.path=='/gacha'?'':
                                $route.path=='/myGacha'?'':
                                    $route.path=='/cardShop'?'':
                            $route.path=='/testMode'?$t("studentProgramme.homework"):''
      }}
    </div>

    <div class="header-right" v-show="!['/tasks', '/coinRecord', '/help', '/gacha', '/myGacha', '/cardShop'].includes($route.path)">
      <div class="box-mode">
        <div class="box-bg1 cursor-pointer"  :class="$route.path=='/adventure'?'active':''" @click="modeChange(1)"></div>
        <span class="text">{{ $t("studentProgramme.adventureMode") }}</span>
      </div>
      <div class="box-mode" style="margin:0 1rem;">
        <div class="box-bg2 cursor-pointer" :class="$route.path=='/libraryMode'?'active':''" @click="modeChange(2)"></div>
        <span class="text">{{ $t("studentProgramme.libraryMode") }}</span>
      </div>
      <div class="box-mode">
        <div class="box-bg3 cursor-pointer" :class="$route.path=='/testMode'?'active':''" @click="modeChange(3)"></div>
        <span class="text">{{ $t("studentProgramme.homework") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      currentGradeName: null,
      showAll: false,
      gradeId: 1
    };
  },
  mounted() {
    this.gradeId = this.$store.getters.currentGradeId
    this.currentGradeName = this.detail.subscriptions[this.detail.subscriptionIndex].subscribeAssignGrades.filter(item => item.id == this.gradeId)[0]?.name
  },
  methods: {
    getGrade(gradeId) {
      this.gradeId = gradeId
      this.$store.dispatch('setGradeId', gradeId);
      this.currentGradeName = this.detail.subscriptions[this.detail.subscriptionIndex].subscribeAssignGrades.find(item => item.id == this.gradeId)?.name || this.detail.subscriptions[this.detail.subscriptionIndex].gradeName
    },

    gradeChange(item) {
      this.currentGradeName = item.name
      this.gradeId = item.id
      this.$store.dispatch('setGradeId', item.id);
      this.$emit('gradeChange', item.id);
      this.showAll = false
    },

    modeChange(index) {
      if (index == 1) this.$router.push({ path: "/adventure" });
      if (index == 2) this.$router.push({ path: "/libraryMode" });
      if (index == 3) this.$router.push({ path: "/testMode" });
    }
  },
};
</script>

<style lang="scss" scoped>
// 定义响应式断点
$phoneMaxWidth: 767px;
$tabletMinWidth: 768px;
$tabletMaxWidth: 1024px;
$desktopMinWidth: 1025px;

// 基础样式 - PC端
.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 2.5vw;
  font-weight: bold;
  z-index: 1;

  // 左侧区域
  .header-left {
    display: flex;
    align-items: center;
    flex: 1;
  }

  // 右侧区域
  .header-right {
    display: flex;
    flex: 1;
    justify-content: flex-end;
  }

  // 年级选择框
  .box-grade {
    padding: 0.5rem 0;
    background-color: #F9F7F2;
    box-shadow: 0px 0.25rem 0.25rem 0px #DEF0F8;
    font-size: 3rem;
    line-height: 3.5rem;
    border-radius: 10rem;
    position: relative;

    span {
      padding: 0 0.75rem;
      display: inline-flex;
      align-items: center;
    }

    .el-icon-caret-bottom {
      margin-left: 1rem;
      font-size: 1rem;
      padding: 0.75rem;
      color: #ffffff;
      border-radius: 50%;
      background-color: #F1AA55;
      box-shadow: 0px 0.5rem 0px #D07D11;
      vertical-align: middle;
    }

    .box-grades {
      margin-top: 1.5rem;
      position: absolute;
      background: #F9F7F2;
      border-radius: 1.25rem;
      width: 100%;
      padding: 0.25rem 0;
      font-size: 1.5rem;
      line-height: 2rem;
      z-index: 2000;
      box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);

      .grades {
        border-radius: 0.75rem;
        margin: 0.75rem;
        padding: 1rem 0.75rem;
        cursor: pointer;

        &.active {
          background-color: #F6C98E;
        }

        &:hover {
          background-color: #f5e8d0;
        }
      }
    }
  }

  // 星星计数
  .box-star {
    margin-left: 4.25rem;
    padding: 0.375rem 1.5rem;
    background-color: #F9F7F2;
    box-shadow: 0px 0.25rem 0.5rem 0px #DEF0F8;
    border-radius: 0.625rem;
    position: relative;
    font-size: 1.5rem;

    &::before {
      content: "";
      background-image: url("~@/assets/images/star-semi.png");
      position: absolute;
      height: 4rem;
      width: 4rem;
      top: -1rem;
      left: -3rem;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  // 标题
  .title {
    color: #ffffff;
    font-size: 3rem;
    flex: 1;
    text-align: center;
    font-weight: 700;
    font-family: "GenSenRoundedTW", "Helvetica", "Arial";
    text-shadow: 0px 4px 4px rgba(0,0,0,0.8);
  }

  // 模式选择
  .box-mode {
    display: flex;
    flex-direction: column;
    align-items: center;

    [class^=box-bg] {
      background-color: #CCCCCC;
      background-size: 75% auto;
      background-repeat: no-repeat;
      background-position: center center;
      box-shadow: 0px 0.375rem 0px #DDA516, 0px 0.1875rem 0px #DDA516 inset;
      border: 0.375rem solid #FCC03A;
      border-radius: 50%;
      width: 4rem;
      height: 4rem;
      cursor: pointer;
      transition: all 0.2s ease;

      &.active {
        background-color: #FCC03A;
        transform: scale(1.05);
      }

      &:hover {
        transform: scale(1.05);
      }
    }

    .box-bg1 {
      background-image: url("~@/assets/images/adventure-mode.png");
    }

    .box-bg2 {
      background-image: url("~@/assets/images/library-mode.png");
    }

    .box-bg3 {
      background-size: 60% auto;
      background-image: url("~@/assets/images/homework-mode.png");
    }

    .text {
      margin-top: 0.875rem;
      font-size: 1.5rem;
      line-height: 1;
      color: #ffffff;
      text-shadow: 0px 2px 2px rgba(0,0,0,0.5);
    }
  }
}

// 平板适配
@media (min-width: $tabletMinWidth) and (max-width: $tabletMaxWidth) {
  .header {
    .title {
      font-size: 2.5rem;
    }

    .box-grade {
      font-size: 2.25rem;

      .el-icon-caret-bottom {
        padding: 0.6rem;
        font-size: 0.9rem;
      }
    }

    .box-star {
      font-size: 1.25rem;
      padding: 0.3rem 1.25rem;

      &::before {
        height: 3.5rem;
        width: 3.5rem;
        top: -0.75rem;
        left: -2.5rem;
      }
    }

    .box-mode {
      [class^=box-bg] {
        width: 3.5rem;
        height: 3.5rem;
        border-width: 0.3rem;
      }

      .text {
        font-size: 1.25rem;
        margin-top: 0.75rem;
      }
    }
  }
}

// 手机端适配 - 核心优化
@media (max-width: $phoneMaxWidth) {
  .header {
    padding: 0.5rem 5vw;
    flex-wrap: wrap;
    min-height: 6rem;

    // 重新布局：标题在上，其他内容在下
    .title {
      width: 100%;
      flex: none;
      font-size: 1.8rem;
      margin-bottom: 0.5rem;
      text-shadow: 0px 2px 2px rgba(0,0,0,0.5);
    }

    .header-left, .header-right {
      flex: none;
      width: 100%;
      justify-content: center;
    }

    .header-left {
      margin-bottom: 0.5rem;
      justify-content: center;
    }

    // 年级选择框优化
    .box-grade {
      font-size: 1.5rem;
      line-height: 2rem;
      padding: 0.25rem 0;

      span {
        padding: 0 0.5rem;
      }

      .el-icon-caret-bottom {
        margin-left: 0.5rem;
        padding: 0.5rem;
        font-size: 0.8rem;
        box-shadow: 0px 0.3rem 0px #D07D11;
      }

      .box-grades {
        font-size: 1.2rem;
        margin-top: 1rem;
        min-width: 100%;

        .grades {
          margin: 0.5rem;
          padding: 0.75rem 0.5rem;
        }
      }
    }

    // 星星计数优化
    .box-star {
      margin-left: 1.5rem;
      padding: 0.25rem 1rem;
      font-size: 1rem;

      &::before {
        height: 2.5rem;
        width: 2.5rem;
        top: -0.5rem;
        left: -1.5rem;
      }
    }

    // 模式选择优化（横向紧凑排列）
    .box-mode {
      [class^=box-bg] {
        width: 2.8rem;
        height: 2.8rem;
        border-width: 0.25rem;
        box-shadow: 0px 0.25rem 0px #DDA516, 0px 0.125rem 0px #DDA516 inset;
      }

      .text {
        font-size: 0.9rem;
        margin-top: 0.5rem;
        white-space: nowrap;
      }
    }

    .box-mode + .box-mode {
      margin: 0 0.8rem !important;
    }
  }
}

// 小屏手机额外优化
@media (max-width: 480px) {
  .header {
    .box-mode {
      [class^=box-bg] {
        width: 2.5rem;
        height: 2.5rem;
      }

      .text {
        font-size: 0.8rem;
      }
    }

    .box-mode + .box-mode {
      margin: 0 0.5rem !important;
    }
  }
}
</style>